// Brand assets and constants for Resham Drops
export const LOGO_URL =
    "https://customer-assets-jai6qajn.emergentagent.net/job_b9da4ea4-b5b2-49bf-a1fa-9b70f140175e/artifacts/8vh0c6un_logo.jpg";

export const PRODUCT_IMAGES = {
    main: "https://customer-assets-jai6qajn.emergentagent.net/job_b9da4ea4-b5b2-49bf-a1fa-9b70f140175e/artifacts/3eqa62tl_product%20main%20image.jpeg",
    alt1: "https://customer-assets-jai6qajn.emergentagent.net/job_b9da4ea4-b5b2-49bf-a1fa-9b70f140175e/artifacts/w9ekx0rp_product%20image%202.jpeg",
    alt2: "https://customer-assets-jai6qajn.emergentagent.net/job_b9da4ea4-b5b2-49bf-a1fa-9b70f140175e/artifacts/l1amjhkn_product%20image%204.jpeg",
};

export const BEFORE_AFTER = [
    {
        before: "/images/results/before_1.png",
        after: "/images/results/after_1.png",
        title: "Sar ke beech mein naye baal",
        quote:
            "Pehle boht hair fall tha, kanghi karte hi baal haath mein aa jate thay. 15 din mein hair fall kaafi kam ho gaya aur 4th week tak sar ke beech mein chhote chhote naye baal nazar aane lage.",
        name: "Ayesha K., Lahore",
        afterLabel: "4 HAFTE BAAD",
    },
    {
        before: "/images/results/before_2.png",
        after: "/images/results/after_2.png",
        title: "Kanpatiyon pe baal wapas aaye",
        quote:
            "Pindi ka paani boht kharab hai, is liye mujhe yaqeen nahi tha ke farq parega. Lekin 6 hafte mein kanpatiyon pe baal wapas ghane hone lage. Ab mirror dekh ke tension nahi hoti.",
        name: "Hamza R., Rawalpindi",
        afterLabel: "6 HAFTE BAAD",
    },
    {
        before: "/images/results/before_3.png",
        after: "/images/results/after_3.png",
        title: "Baal ghane aur mazboot",
        quote:
            "Pehle meri choti boht patli ho gayi thi, ab saaf mota pan nazar aata hai. Main roz raat sone se pehle 5 qatray laga ke halka sa massage karti hoon, ab baal strong ho gaye hain.",
        name: "Zainab M., Karachi",
        afterLabel: "12 HAFTE BAAD",
    },
];

export const CITIES = [
    "Karachi",
    "Lahore",
    "Islamabad",
    "Rawalpindi",
    "Faisalabad",
    "Multan",
    "Peshawar",
    "Gujranwala",
    "Sialkot",
    "Quetta",
    "Hyderabad",
    "Bahawalpur",
    "Sargodha",
    "Abbottabad",
    "Other City in Pakistan",
];

export const CONTACT = {
    email: "reshamdrops@gmail.com",
};
